import React from 'react';

const icon = `${EASYCOMMERCE.assets}admin/img/nofound/no-customer.png`;

const NoFound = ({ handleAddNew }) => {
    return (
        <>
            <div className="text-center py-[120px]">
            <img className="mx-auto mb-[35px] w-[95px] h-[115px]" src={icon} alt="" />
            <h2 className="font-inter text-2xl mb-[5px] font-medium leading-8 text-ec-title">
               No Taxation methods configured
            </h2>
            <p className="font-inter text-base mb-6 font-normal text-ec-light-black">
                All type of payment activities will <br></br> appear here once they occur.
            </p>
            <button
                onClick={handleAddNew}
                className="h-[45px] text-ec-primary font-inter text-base px-8 border border-ec-primary rounded-lg hover:text-white hover:bg-ec-primary transition-all 
                        ease-in-out duration-500"
            >
                Add Class
            </button>
        </div>
        </>
    );
};

export default NoFound;
